import TagBar from './TagBar';

export default TagBar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TagBar/index.ts